import { DocStatusEnum } from '~/modules/identification/forms/Documents/types.ts';
import { WARNING_MESSAGES_STATUSES } from '~/modules/identification/forms/Documents/constants.tsx';

export const useGetWarningMessageByStatuses = (
  statuses: DocStatusEnum[] | DocStatusEnum | null | undefined
) => {
  const statusesArray = Array.isArray(statuses) ? statuses : statuses ? [statuses] : [];
  if (!statusesArray.length) return '';

  if (statusesArray.includes(DocStatusEnum.INVALID_SIGNATURE)) {
    return WARNING_MESSAGES_STATUSES[DocStatusEnum.INVALID_SIGNATURE];
  }
  if (statusesArray.includes(DocStatusEnum.SIGNED_WITH_ELECTRONIC_STAMP)) {
    return WARNING_MESSAGES_STATUSES[DocStatusEnum.SIGNED_WITH_ELECTRONIC_STAMP];
  }

  const statusNames = statusesArray
    .map((status) => WARNING_MESSAGES_STATUSES[status])
    .filter(Boolean);

  if (!statusNames.length) return '';
  const formattedStatuses = statusNames.join(', ');

  return `Після перевірки документів виявлено, що цей документ має некоректні або невідповідні дані: ${formattedStatuses}. Будь ласка, перевірте документ та підпишіть його повторно.`;
};
